/** 控件数据来源 - 枚举  */
export enum WidgetSource {
  /** 认证姓名 */
  CERTIFIED_NAME = 'CERTIFIED_NAME',

  /** 认证身份证 */
  CERTIFIED_ID = 'CERTIFIED_ID',

  /** 认证证件号 */
  CERTIFIED_CREDENTIAL = 'CERTIFIED_CREDENTIAL',

  /** 认证企业名称 */
  CERTIFIED_CORP_NAME = 'CERTIFIED_CORP_NAME',

  /** 统一社会信用代码 */
  CERTIFIED_CORP_USCC = 'CERTIFIED_CORP_USCC'
}

/** 控件数据来源项 */
export interface WidgetSourceItem {
  /** 来源名称 */
  name: string

  /** 来源 key */
  key: string | WidgetSource

  /** 来源图标 */
  icon?: string
}

/** 认证图标 */
const IconCertified = 'fa-icon-auth'

/** 控件数据来源 - 列表 */
export const WidgetSources: WidgetSourceItem[] = [
  {
    name: '认证姓名',
    key: WidgetSource.CERTIFIED_NAME,
    icon: IconCertified
  },
  {
    name: '认证身份证',
    key: WidgetSource.CERTIFIED_ID,
    icon: IconCertified
  },
  {
    name: '认证证件号',
    key: WidgetSource.CERTIFIED_CREDENTIAL,
    icon: IconCertified
  },
  {
    name: '认证企业名称',
    key: WidgetSource.CERTIFIED_CORP_NAME,
    icon: IconCertified
  },
  {
    name: '统一社会信用代码',
    key: WidgetSource.CERTIFIED_CORP_USCC,
    icon: IconCertified
  }
]
